import SEO from '../../components/base/SEO';
import Header from './components/Header';
import Hero from './components/Hero';
import BasicSpecs from './components/BasicSpecs';
import Merits from './components/Merits';
import DiscountGuide from './components/DiscountGuide';
import AccountGuide from './components/AccountGuide';
import Demerits from './components/Demerits';
import Reviews from './components/Reviews';
import SuitableFor from './components/SuitableFor';
import HowToApply from './components/HowToApply';
import CTASection from './components/CTASection';
import Footer from './components/Footer';
import Breadcrumb from '../../components/feature/Breadcrumb';

export default function JACard() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "FinancialProduct",
    "name": "地域密着型クレジットカード",
    "description": "農協グループが発行する地域密着型クレジットカード。農協系ガソリンスタンドや農協グループ店舗での特典が充実。地域で生活する方に最適なカードです。",
    "brand": {
      "@type": "Brand",
      "name": "農協系クレジットカード"
    },
    "offers": {
      "@type": "Offer",
      "price": "0",
      "priceCurrency": "JPY",
      "availability": "https://schema.org/InStock"
    },
    "url": `${siteUrl}/ja`
  };

  return (
    <div className="min-h-screen bg-white">
      <SEO
        title="地域密着型クレジットカード詳細｜農協系カードのメリット・特典｜クレカ比較ナビ"
        description="農協グループが発行する地域密着型クレジットカードの詳細情報。農協系ガソリンスタンド・店舗での特典、ポイント制度、付帯保険、申込方法を徹底解説します。"
        keywords="農協系カード,地域密着型,クレジットカード,農協グループ,ガソリンスタンド特典,地方,おすすめ"
        canonical="/ja"
        structuredData={structuredData}
      />
      <Header />
      <Breadcrumb items={[
        { label: 'ホーム', path: '/' },
        { label: 'カード詳細', path: '/ranking' },
        { label: '地域密着型クレジットカード' }
      ]} />
      <Hero />
      <CTASection />
      <BasicSpecs />
      <Merits />
      <DiscountGuide />
      <AccountGuide />
      <Demerits />
      <CTASection />
      <Reviews />
      <SuitableFor />
      <HowToApply />
      <CTASection />
      <Footer />
    </div>
  );
}
